import ProjectInvitationDecline from './ProjectInvitationDecline';
export default ProjectInvitationDecline;